import {border, borderColor} from 'polished'

// import type { ThemeConfig } from "antd";
const AntdConfig = {
  token: {
    fontFamily: 'IBM Plex Sans Devanagari',
    colorPrimary: '#0c4da2',
    colorError: '#ed1c24',
    fontSize: 13,
    colorTextDisabled: '#000',
  },
  components: {
    Spin: {
      colorPrimary: '#0c4da2',
    },
    Result: {
      colorTextDescription: '#000',
      subtitleFontSize: 13,
    },
    Layout: {
      headerBg: 'white',
      headerPadding: '0 20px',
      headerHeight: 66,
      bodyBg: 'transparent',
    },
    Typography: {
      colorTextHeading: '#0c4da2',
      colorText: '#0c4da2',
    },
    Radio: {
      colorPrimary: '#0c4da2',
      radioSize: 16,
      dotSize: 8,
      lineHeight: 1,
      wireframe: true,
      colorBgContainerDisabled: '#9f9f9f75',
    },
    Button: {
      borderRadius: 10,
      padding: '0 20px', // This replaces paddingInline with padding
      fontSize: 14,
      lineHeight: 0,
      colorBorder: '#C5161D',
      colorPrimary: '#C5161D',
      primaryColor: '#fff',
      colorPrimaryBorder: '#C5161D',
      colorPrimaryHover: '#a31319',
      colorPrimaryActive: '#a31319',
      primaryShadow: 'none',

      defaultBg: '#fff',
      defaultBorderColor: '#C5161D',
      defaultColor: '#C5161D',
      defaultActiveBg: '#a31319',
      defaultActiveColor: '#ffffff',
      defaultHoverColor: '#ffffff',
      defaultHoverBg: '#a31319',
      defaultHoverBorderColor: '#a31319',
      borderColorDisabled: '#d9d9d9',

      colorLink: '#C5161D',
      colorLinkActive: '#C5161D',
      colorLinkHover: '#a31319',
    },
    Input: {
      borderRadius: 5,
      borderRadiusSM: 5,
      borderRadiusLG: 5,
      controlHeight: 35,
      controlHeightSM: 35,
      controlHeightLG: 35,
      fontSize: 14,
      activeShadow: '0 0 0 2px rgba(5, 145, 255, 0.1)',
      fontSizeIcon: 20,
      colorIcon: '#0c4da2',
      colorBorder: '#919599',
      hoverBorderColor: '#0c4da2',
      colorBgContainerDisabled: '#9f9f9f75',
    },
    Tag: {
      borderRadiusSM: 2,
      fontSize: 14,
      colorWarning: 'rgb(232, 111, 37)',
      colorWarningBorder: '#FFBB96',
      colorWarningBg: 'rgb(254, 241, 225)',

      colorInfo: 'rgb(44, 92, 197)',
      colorInfoBorder: 'rgb(44, 92, 197)',
      colorInfoBg: 'rgb(229, 242, 253)',
    },
    Card: {
      padding: 6,
      border: 'red',
    },
    Table: {
      borderRadius: 0,
      borderRadiusLG: 0,
      colorBgContainer: '#ffffff',
      fontWeightStrong: 500,
      paddingContentVertical: 14,
      colorBorderSecondary: '#DFE0E2',
      colorText: 'rgba(0, 0, 0, 0.65)',
      cellPaddingBlock: 10,
      cellFontSize: 14,
      headerBg: '#0c4da2',
      headerColor: '#FFFFFF',
      headerSortHoverBg: '#00833C',
      headerSortActiveBg: '#00833C',

      headerSplitColor: 'rgb(44, 92, 197)',
      // "rowHoverBg": "rgb(82, 196, 26)",
    },

    Menu: {
      borderRadius: 0,
      radiusItem: 0,
      // dropdownWidth: 160,
      itemBorderRadius: 2,
      radiusSubMenuItem: 0,
      subMenuItemBorderRadius: 0,
      itemColor: 'rgba(0, 0, 0, 0.85)',
      itemSelectedColor: '#1890FF',
      margin: 0,
      fontSize: 14,
      itemHeight: 45,

      // colorBgContainer: "#ffffff",
    },
    Cascader: {
      controlItemBgActive: '#e6f4ff',
      borderRadiusSM: 2,
      fontSizeIcon: 12,
    },
    Checkbox: {
      fontSize: 14,
      colorPrimaryTextHover: '#0c4da2',
      colorBgContainerDisabled: '#9f9f9f75',
    },
    Collapse: {
      headerBg: 'rgba(255, 255, 255, 0.02)',
      colorText: 'rgb(97, 97, 97)',
      colorTextHeading: 'rgb(51, 51, 51)',
      colorBorder: 'rgba(0,0,0,0)',
    },
    Slider: {
      trackBg: 'rgb(236, 33, 39)',
      railBg: '#FFDEDE',
      railHoverBg: 'rgb(236, 33, 39)',
      colorBgElevated: 'rgb(25,135,84)',
      handleColor: 'rgb(255, 255, 255)',
      handleActiveColor: 'rgb(255, 255, 255)',
      trackHoverBg: 'rgb(236, 33, 39)',
      dotActiveBorderColor: 'rgb(255, 255, 255)',
      colorPrimaryBorderHover: 'rgb(255, 255, 255)',
    },

    InputNumber: {
      borderRadius: 5,
      borderRadiusSM: 5,
      borderRadiusLG: 5,
      controlHeight: 35,
      controlHeightSM: 35,
      controlHeightLG: 35,
      fontSize: 14,
      colorBorder: '#919599',
      hoverBorderColor: '#0c4da2',
      // hoverBg: "rgba(255, 255, 255, 0)",
      handleHoverColor: 'rgba(22, 119, 255, 0)',
      activeBorderColor: '#0c4da2',
      hoverBorderColor: '#707C8B',
      colorPrimary: 'rgb(217, 217, 217)',
      addonBg: 'rgb(255, 255, 255)',
    },
    Select: {
      borderRadius: 5,
      colorPrimary: 'rgb(51, 51, 51)',
      colorPrimaryHover: 'rgba(51, 51, 51, 0.7)',
      colorBgContainerDisabled: '#9f9f9f75',
      controlOutline: '#919599',
      controlOutlineWidth: 0,
      singleItemHeightLG: 20,
      singleItemHeightSM: 20,
      singleItemHeight: 20,
      multipleItemHeight: 32,
      borderRadiusLG: 5,
      borderRadiusSM: 5,
      borderRadiusXS: 5,
      optionSelectedColor: '#ffffff',
      colorText: '#161616',
      optionSelectedBg: '#0c4da2',
      controlHeight: 35,
      controlHeightSM: 35,
      optionSelectedFontWeight: 500,
      colorBorder: '#919599',
      hoverBorderColor: '#0c4da2',
    },
    // Select: {
    //   borderRadius: 5,
    //   colorPrimary: 'rgb(51, 51, 51)',
    //   colorPrimaryHover: 'rgba(51, 51, 51, 0.7)',
    //   controlOutline: '#919599',
    //   controlOutlineWidth: 0,
    //   singleItemHeightLG: 56,
    //   singleItemHeightSM: 44,
    //   singleItemHeight: 44,
    //   multipleItemHeight: 44,

    //   borderRadiusLG: 5,
    //   borderRadiusSM: 5,
    //   borderRadiusXS: 5,
    //   colorTextPlaceholder: 'rgb(51,51,51)',
    //   optionSelectedColor: '#ffffff',
    //   colorText: '#161616',
    //   optionSelectedBg: '#0c4da2',
    //   controlHeight: 35,
    //   controlHeightSM: 35,
    //   optionSelectedFontWeight: 500,
    //   colorBorder: '#919599',
    //   hoverBorderColor: '#0c4da2',
    // },
    Modal: {},
    Drawer: {
      colorBgMask: 'rgba(0,0,0,0.45)',
      padding: 15,
      paddingLG: 15,
      paddingXS: 15,
    },
    Pagination: {
      colorPrimary: 'rgb(197,22,29)',
      fontWeightStrong: 700,
      colorPrimaryHover: 'rgb(197,22,29)',
      colorBgTextActive: 'rgb(197,22,29)',
    },
    Dropdown: {
      borderRadius: 5,
      colorBorder: '#919599',
      hoverBorderColor: '#0c4da2',
    },
    Form: {
      labelFontSize: 13,
      fontSize: 14,
      labelHeight: 'auto',
      lineHeight: 1.3,
      itemMarginBottom: 0,
      verticalLabelPadding: 0,
    },
    DatePicker: {
      controlHeight: 35,
      colorBorder: '#919599',
      hoverBorderColor: '#0c4da2',
      colorBgContainerDisabled: '#9f9f9f75',
    },
    RangePicker: {
      placements: 'bottomLeft',
      marginTop: '1rem',
    },
    Steps: {
      lineWidth: 10,
      colorPrimary: '#ED1C24',
      iconSize: 60,
      customIconSize: 60,
      //  fontSize: 20,
      iconFontSize: 20,
      lineHeight: 2,
    },
  },
}

export default AntdConfig
